import { Children } from 'react';
import { Flex } from '../../../GlobalComponents/Flex';

export type RowProps = React.HTMLAttributes<HTMLDivElement> & {
	image?: React.ReactNode;
	left?: React.ReactNode;
	right?: React.ReactNode;
	children?:
		| [left: React.ReactNode, right: React.ReactNode]
		| [
				image: React.ReactNode,
				left: React.ReactNode,
				right: React.ReactNode
		  ];
};

export const Row: React.FC<RowProps> = ({ image, left, right, children }) => {
	let i: React.ReactNode | undefined;
	let l: React.ReactNode | undefined;
	let r: React.ReactNode | undefined;

	const childArray = Children.toArray(children);

	if (childArray.length === 2) {
		[l, r] = childArray;
	}

	if (childArray.length === 3) {
		[i, l, r] = childArray;
	}

	const hasImage = Boolean(image ?? i);

	return (
		<Flex $alignItems="center">
			{hasImage && (
				<div
					className="d-none d-md-block align-self-center"
					style={{ width: 55 }}
				>
					{image ?? i}
				</div>
			)}

			<div className="mr-auto">{left ?? l}</div>

			<div className="text-right">{right ?? r}</div>
		</Flex>
	);
};
